import React from 'react';
import { Box, Typography, Link, Container } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import rareLogo from '../assets/rare_logo.png';

const Footer = () => {
  return (
  <Box
    component="footer"
    sx={{
      width: '100%',
        mt: 0,
        py: 5,
        backgroundColor: '#1A3E5F',
    }}
  >
      <Container 
        maxWidth="xl" 
      sx={{
          px: { xs: 2, sm: 3, md: 4 },
      }}
      >
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
            gap: 3,
      }}
    >
          {/* Logo & Title */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <Box
          component="img"
          src={rareLogo}
          alt="Rare Logo"
          sx={{
                width: 32,
                height: 32,
            objectFit: 'contain',
                filter: 'brightness(0) invert(1)',
          }}
        />
        <Typography
          variant="h6"
          sx={{
                fontWeight: 600,
                color: '#FFFFFF',
                fontSize: '1rem',
          }}
        >
              Fish Forever Impact Framework
        </Typography>
          </Box>

          {/* Links */}
          <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: { xs: 1.5, sm: 3 } }}>
            <Link 
              component={RouterLink} 
              to="/privacy" 
              sx={{ 
                color: 'rgba(255, 255, 255, 0.7)',
                fontSize: '0.875rem',
                textDecoration: 'none',
                fontWeight: 500,
                transition: 'color 200ms',
                '&:hover': {
                  color: '#FFFFFF',
                }
              }}
            >
            Privacy Policy
          </Link>
            <Link 
              component={RouterLink} 
              to="/terms" 
              sx={{ 
                color: 'rgba(255, 255, 255, 0.7)',
                fontSize: '0.875rem',
                textDecoration: 'none',
                fontWeight: 500,
                transition: 'color 200ms',
                '&:hover': {
                  color: '#FFFFFF',
                }
              }}
            >
            Terms
          </Link>
          <Link
              component={RouterLink} 
              to="/changelog" 
              sx={{ 
                color: 'rgba(255, 255, 255, 0.7)',
                fontSize: '0.875rem',
                textDecoration: 'none',
                fontWeight: 500,
                transition: 'color 200ms',
                '&:hover': {
                  color: '#FFFFFF',
                }
              }}
          >
            Changelog
          </Link>
            <Link
              component={RouterLink} 
              to="/user-guide" 
              sx={{ 
                color: 'rgba(255, 255, 255, 0.7)',
                fontSize: '0.875rem',
                textDecoration: 'none',
                fontWeight: 500,
                transition: 'color 200ms',
                '&:hover': {
                  color: '#FFFFFF',
                }
              }}
            >
              User Guide
            </Link>
    </Box>

          {/* Copyright */}
          <Typography 
            variant="body2" 
            sx={{ 
              color: 'rgba(255, 255, 255, 0.5)',
              fontSize: '0.8125rem',
              textAlign: 'center',
            }}
          >
            &copy; {new Date().getFullYear()} Rare. All rights reserved.
          </Typography>
        </Box>
      </Container>
  </Box>
  );
};

export default Footer; 